export const type = 'l2ao';

export const GET_LEAD_OWNER = 'GET_LEAD_OWNER';

export const SET_OWNER_INFO = 'SET_OWNER_INFO';

export const OWNER_INFO = 'OWNER_INFO';
export const HAS_OWNER = 'HAS_OWNER';

export const state = () => ({
  ownerInfo: undefined
});

export const actions = {
  async [GET_LEAD_OWNER]({ getters, state, commit }, { leadEmail, demoTemplateId }) {
    const encodedEmail = btoa(leadEmail); // base64 encoding it for obfuscation reasons (see backend)
    await this.$axios.get(
      'api/v1/appointments/l2ao', { params: { search: encodedEmail, demo_template_id: demoTemplateId } }
    ).then((response) => {
      const ownerInfo = response.data.data.attributes;
      commit(SET_OWNER_INFO, { ownerInfo });
    }).catch((err) => {
      if (err.response.status !== 404) {
        console.error(err);
      }
    });
  }
};

export const mutations = {
  [SET_OWNER_INFO](state, { ownerInfo }) {
    state.ownerInfo = ownerInfo;
  }
};

export const getters = {
  [OWNER_INFO](state, getters) {
    return state.ownerInfo;
  },
  [HAS_OWNER](state, getters) {
    return state.ownerInfo !== undefined && state.ownerInfo.user !== null;
  }
};
